export default {
	name	: 'CourseStructureTree',
	props	: {
		structure	: {
			type		: Object,
			required	: true
		},
		selected	: {
			type		: Array,
			required	: true
		},
		search		: {
			type		: String,
			default		: ''
		}
	},
	computed: {
		filteredStructure() {
			if (!this.search || this.search.trim() === '') {
				return this.structure
			}
			
			const searchLower = this.search.toLowerCase()
			
			const filteredModules = this.structure.modules
			.map(module => {
				const filteredLessons = module.lessons
				.map(lesson => {
					const filteredMaterials = lesson.materials.filter(m =>
						m.name.toLowerCase().includes(searchLower)
					)
					
					const filteredHomeworks = lesson.homeworks.filter(hw =>
						hw.name.toLowerCase().includes(searchLower)
					)
					
					if (
						lesson.name.toLowerCase().includes(searchLower) ||
						filteredMaterials.length > 0 ||
						filteredHomeworks.length > 0
					) {
						return {
							...lesson,
							materials: filteredMaterials.length > 0 ? filteredMaterials : lesson.materials,
							homeworks: filteredHomeworks.length > 0 ? filteredHomeworks : lesson.homeworks
						}
					}
					
					return null
				})
				.filter(l => l !== null)
				
				if (
					module.name.toLowerCase().includes(searchLower) ||
					filteredLessons.length > 0
				) {
					return {
						...module,
						lessons: filteredLessons
					}
				}
				
				return null
			})
			.filter(m => m !== null)
			
			return {
				...this.structure,
				modules: filteredModules
			}
		}
	},
	methods: {
		// Material selection
		isMaterialSelected(material) {
			return material.hasAccess;
			
			//return this.selected.includes(materialId)
		},
		toggleMaterial(item) {
			//let newSelected = [...this.selected]
			//const index = newSelected.indexOf(materialId)
			
			//if (index > -1) {
			//	newSelected.splice(index, 1)
			//} else {
			//	newSelected.push(materialId)
			//}
			
			console.log('toggleMaterial:', item);
			
			item.hasAccess = !item.hasAccess;
			
			this.$emit('update')
		},
		// Lesson selection
		getAllLessonMaterialIds(lesson) {
			return [
				...lesson.materials.map(m => m.id),
				...lesson.homeworks.map(hw => hw.id)
			]
		},
		isLessonSelected(lesson) {
			return lesson.hasAccess;
			
			//const allIds = this.getAllLessonMaterialIds(lesson)
			
			//return allIds.length > 0 && allIds.every(id => this.selected.includes(id))
		},
		isLessonIndeterminate(lesson) {
			const allIds = this.getAllLessonMaterialIds(lesson)
			const selectedCount = allIds.filter(id => this.selected.includes(id)).length
			
			return selectedCount > 0 && selectedCount < allIds.length
		},
		toggleLesson(lesson) {
			console.log('toggleLesson:', lesson);
			
			const status = !lesson.hasAccess;
			
			lesson.hasAccess = status;
			
			lesson.homeworks.forEach(homework => {
				homework.hasAccess = status;
			})
			
			lesson.materials.forEach(material => {
				material.hasAccess = status;
			})
			
			this.$emit('update')
		},
		getLessonSelectionText(lesson) {
			//const allIds = this.getAllLessonMaterialIds(lesson)
			//const selectedCount = allIds.filter(id => this.selected.includes(id)).length
			
			var selectedCount = 0;
			
			lesson.materials.forEach(material => {
				if(this.isMaterialSelected(material)){
					selectedCount += 1;
				}
			})
			
			return `${selectedCount} / ${lesson.materials.length}`
		},
		// Module selection
		getAllModuleMaterialIds(module) {
			const ids = []
			
			module.lessons.forEach(lesson => {
				lesson.materials.forEach(m => ids.push(m.id))
				lesson.homeworks.forEach(hw => ids.push(hw.id))
			})
			
			return ids
		},
		isModuleSelected(module) {
			return module.hasAccess;
			
			//const allIds = this.getAllModuleMaterialIds(module)
			
			//return allIds.length > 0 && allIds.every(id => this.selected.includes(id))
		},
		isModuleIndeterminate(module) {
			const allIds = this.getAllModuleMaterialIds(module)
			const selectedCount = allIds.filter(id => this.selected.includes(id)).length
			
			return selectedCount > 0 && selectedCount < allIds.length
		},
		toggleModule(module) {
			console.log('toggleModule:', module);
			
			const status = !module.hasAccess;
			
			module.hasAccess = status;
			
			module.lessons.forEach(lesson => {
				console.log('lesson:', lesson);
				
				lesson.hasAccess = status;
				
				lesson.homeworks.forEach(homework => {
					homework.hasAccess = status;
				})
				
				lesson.materials.forEach(material => {
					material.hasAccess = status;
				})
			})
			
			this.$emit('update')
		},
		getModuleSelectionText(module) {
			//const allIds = this.getAllModuleMaterialIds(module)
			
			//const selectedCount = allIds.filter(id => this.selected.includes(id)).length
			var selectedCount = 0;
			
			module.lessons.forEach(lesson => {
				if(this.isLessonSelected(lesson)){
					selectedCount += 1;
				}
			})
			
			return `${selectedCount} / ${module.lessons.length}`
		},
		// Material icons and colors
		getMaterialIcon(type) {
			const icons = {
				video	: 'mdi-file-video',           // MP4, video files
				text	: 'mdi-file-document',         // Google Docs style
				audio	: 'mdi-file-music',           // Audio files
				pdf		: 'mdi-file-pdf-box',           // PDF with color box
				image	: 'mdi-file-image',           // PNG, JPEG, image files
				file	: 'mdi-file-outline'           // Generic file
			}
			
			return icons[type] || 'mdi-file-outline'
		},
		getMaterialColor(type) {
			const colors = {
				video	: 'red',
				text	: 'blue',
				audio	: 'purple',
				pdf		: 'orange',
				image	: 'green',
				file	: 'grey'
			}
			
			return colors[type] || 'grey'
		},
		getMaterialTypeLabel(type) {
			const labels = {
				video	: this.$t('video') || 'Відео',
				text	: this.$t('text') || 'Текст',
				audio	: this.$t('audio') || 'Аудіо',
				pdf		: 'PDF',
				image	: this.$t('image') || 'Зображення',
				file	: this.$t('file') || 'Файл'
			}
			
			return labels[type] || type
		}
	}
}
